<template>
    <div
      class="frame"
      :style="{ paddingRight: align === 'left' ? '50px' : '0px' }">
      <div>
        {{ formattedSum }}
      </div>
      <span class="currency">₽</span>
    </div>
</template>

<script>

export default {
  name: 'Frame',
  props: {
    sum: Number,
    align: {
      type: String,
      default: 'right',
    },
  },
  computed: {
    formattedSum() {
      return `${new Intl.NumberFormat('ru-RU').format(this.sum)}`;
    },
  },
};
</script>

<style scoped>
.frame {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  width: 380px;
  height: 60px;
  align-items: center;
  color: #E3E5E4;
  font-family: 'ONY One', serif;
  font-weight: 700;
  font-size: 60px;
  line-height: 100%;
  text-align: right;
  text-transform: uppercase;
  letter-spacing: -2px;
  font-variant-numeric: lining-nums tabular-nums;
}
.currency {
  margin-left: 12px;
}
</style>
